import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const UnauthorizedModal: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener("unauthorized", handler);
    return () => window.removeEventListener("unauthorized", handler);
  }, []);

  const handleConfirm = () => {
    setShow(false);
    history.push("/jobs/list/active?size=10&sortby=0&orderby=1");
  };

  return (
    <Modal show={show} onHide={handleConfirm} backdrop="static" centered>
      <Modal.Header className="brand-primary">
        <Modal.Title>
          <i className="bi bi-shield-exclamation me-2" />
          Unauthorized Access
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your session has expired or you do not have permission to perform this action.
        <br />
        <br />
        Please click <strong>OK</strong> to return to the dashboard.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleConfirm}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnauthorizedModal;
